import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ReactPixel, track } from '../../helpers';
import { CONTEXT_SEARCH } from '../../helpers/trackingStringValues';
import { search } from '../../helpers/routes';
import TrackingEvents from '../../common/models/TrackingEvents';
import Departments from '../../common/models/Departments';
import DepartmentBox from '../DepartmentBox/DepartmentBox';
import SearchDepartment from './SearchDepartment';
import { SearchBoxIcon, SearchInput, SearchWrapper } from './styled';
import withCountryCode from '../RoutesHoc/RoutesHoc';

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handlerDepartment = this.handlerDepartment.bind(this);
    this.handleFocusOutIfMobile = this.handleFocusOutIfMobile.bind(this);

    this.searchInputRef = React.createRef();
    this.searchBoxRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.searchBoxRef.current.addEventListener('focusout', this.handleFocusOutIfMobile);
  }

  componentDidUpdate() {
    if (!this.props.showDepartments) {
      this.searchInputRef.current.blur();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    this.searchBoxRef.current.removeEventListener('focusout', this.handleFocusOutIfMobile);
  }

  handleFocusOutIfMobile(e) {
    const { mobileSubmit } = this.props;
    const { relatedTarget } = e;
    const { searchBoxRef } = this;

    if (!mobileSubmit || !searchBoxRef) {
      return null;
    }

    const { current: searchBox } = searchBoxRef;
    if (!relatedTarget || searchBox === relatedTarget || !searchBox.contains(relatedTarget)) {
      this.submitSearch();
      return null;
    }

    return null;
  }

  handleClickOutside(event) {
    if (this.searchBoxRef && this.searchBoxRef.current && !this.searchBoxRef.current.contains(event.target)) {
      this.props.setVisible(false);
    }
  }

  handleSearchInput(e) {
    this.props.queryUpdated(e.target.value);
  }

  submitSearch(e) {
    if (e) {
      e.preventDefault();
    }

    const { department, searchQuery, buildUrlWithCountry } = this.props;
    const searchDepartment = Departments.getInternalName(department);
    const term = searchQuery.trim();
    if (!term) {
      return;
    }
    ReactPixel.track('Search', { search_string: searchQuery });
    track(TrackingEvents.productsSearched(), {
      categoryDepartment: { department: searchDepartment.toLowerCase() },
      ui: { term }
    });
    window.location = buildUrlWithCountry(search(searchDepartment, term));
  }

  handlerDepartment(department, e) {
    e.stopPropagation();
    this.props.departmentUpdated(department);
    const searchDepartment = Departments.getInternalName(department);
    track(TrackingEvents.departmentSelected(), {
      categoryDepartment: {
        department: searchDepartment.toLowerCase()
      },
      ui: { context: CONTEXT_SEARCH }
    });
    this.searchInputRef.current.focus();
  }

  render() {
    const { department, setVisible, s3BasePath, showDepartments, searchQuery, toggle, mobileSubmit } = this.props;

    return (
      <SearchWrapper
        style={{ display: 'flex' }}
        ref={this.searchBoxRef}
        onClick={() => {
          if (mobileSubmit) {
            toggle();
          }
        }}
        tabIndex="0"
      >
        <form id="search" onSubmit={this.submitSearch} tabIndex="0">
          <div style={{ position: 'relative' }} onClick={e => e.stopPropagation()} tabIndex="0">
            <SearchInput
              type="search"
              onChange={this.handleSearchInput}
              onFocus={() => setVisible(true)}
              onClick={e => e.stopPropagation()}
              value={searchQuery}
              autoComplete="off"
              ref={this.searchInputRef}
              data-cy="input-search-free-text"
              tabIndex="0"
            />

            <SearchDepartment showDepartments={showDepartments} tabIndex="0">
              <DepartmentBox
                context="search"
                department={department}
                handleClick={this.handlerDepartment}
                underline
                fontSize="13px"
                tabIndex="0"
              />
            </SearchDepartment>

            <SearchBoxIcon
              type="image"
              alt="Submit search"
              data-cy="image-search-submit"
              id="Search"
              onClick={e => {
                e.stopPropagation();
                this.submitSearch(e);
              }}
              src={`${s3BasePath}mkt/header/magnifying_glass.svg`}
              tabIndex="0"
            />
          </div>
        </form>
      </SearchWrapper>
    );
  }
}

SearchBox.propTypes = {
  s3BasePath: PropTypes.string.isRequired,
  mobileSubmit: PropTypes.bool,
  showDepartments: PropTypes.bool,
  department: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
  queryUpdated: PropTypes.func,
  departmentUpdated: PropTypes.func,
  setVisible: PropTypes.func
};

export default withCountryCode(SearchBox);
